// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   Transactions summary — four headline cards over two panels.
   Everything here is server-computed (/transactions/summary); the page only
   ever holds one page of rows, so none of it could be derived client-side.
   ========================================================================== */
.txs { margin-bottom: 14px; display: flex; flex-direction: column; gap: 10px; }

/* ---- headline cards ---- */
.txs-cards {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
}
/* Two rows, not one: the icon and label share the top line, the figure and its
   delta sit below, and the sparkline gets the full width underneath. Laid out
   side by side, the sparkline landed on top of "vs. previous 7 days". */
.txs-card {
  position: relative;
  overflow: hidden;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  grid-template-areas:
    "icon  label"
    "body  body"
    "spark spark";
  align-items: center;
  column-gap: 9px;
  row-gap: 2px;
  padding: 12px 14px 0;
  background: var(--surface, #fff);
  border: 1px solid var(--line, #eaebf3);
  border-radius: var(--r-lg, 16px);
  box-shadow: var(--sh-sm, 0 1px 2px rgba(16, 18, 40, 0.05));
}
/* A wash in the card's own tone. Kept faint: these sit above a dense table and
   must not compete with it. */
.txs-card::after {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  opacity: 0.4;
}
.txs-card--violet::after { background: linear-gradient(135deg, rgba(109, 93, 246, 0.07), transparent 60%); }
.txs-card--blue::after   { background: linear-gradient(135deg, rgba(59, 158, 255, 0.07), transparent 60%); }
.txs-card--green::after  { background: linear-gradient(135deg, rgba(15, 185, 129, 0.08), transparent 60%); }

.txs-card__icon {
  grid-area: icon;
  position: relative;
  z-index: 1;
  display: grid;
  place-items: center;
  width: 30px;
  height: 30px;
  border-radius: 9px;
}
.txs-card--violet .txs-card__icon { background: var(--brand-100, #ece9ff); color: var(--brand-600, #6d5df6); }
.txs-card--blue .txs-card__icon   { background: var(--info-soft, #e8f2ff); color: var(--info-ink, #1c73d6); }
.txs-card--green .txs-card__icon  { background: var(--ok-soft, #e6f8f1);  color: var(--ok-ink, #0a8f64); }

.txs-card__body {
  grid-area: body;
  position: relative;
  z-index: 1;
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 4px 10px;
  min-width: 0;
}
.txs-card__label {
  grid-area: label;
  position: relative;
  z-index: 1;
  font-size: 12px;
  font-weight: 500;
  color: var(--t-500, #6c7189);
}
.txs-card__value {
  font-size: 20px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--t-900, #0e1124);
  font-variant-numeric: tabular-nums;
  line-height: 1.2;
  flex: 1 0 100%;
}
.txs-card__delta {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 11.5px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}
.txs-card__delta.is-up { color: var(--ok-ink, #0a8f64); }
.txs-card__delta.is-down { color: var(--err-ink, #ce2649); }
.txs-card__delta.is-flat { color: var(--t-400, #9aa0b6); font-weight: 500; }
.txs-card__sub { font-size: 11px; color: var(--t-400, #9aa0b6); white-space: nowrap; }

/* Bleeds to the card's edges along the bottom, so it reads as a baseline for
   the figure above rather than a floating decoration beside it. */
.txs-spark {
  grid-area: spark;
  position: relative;
  z-index: 1;
  width: calc(100% + 28px);
  margin: 4px -14px 0;
  height: 26px;
  display: block;
  pointer-events: none;
}
.txs-spark__line { fill: none; stroke-width: 2; vector-effect: non-scaling-stroke; stroke-linecap: round; stroke-linejoin: round; }
.txs-spark__area { stroke: none; opacity: 0.16; }
.txs-spark__area--violet { fill: var(--brand-600, #6d5df6); }
.txs-spark__area--blue   { fill: var(--info, #3b9eff); }
.txs-spark__area--green  { fill: var(--ok, #0fb981); }
.txs-spark__line--violet { stroke: var(--brand-600, #6d5df6); }
.txs-spark__line--blue   { stroke: var(--info, #3b9eff); }
.txs-spark__line--green  { stroke: var(--ok, #0fb981); }

/* ---- panels ---- */
.txs-panels {
  display: grid;
  grid-template-columns: minmax(0, 1.35fr) minmax(0, 1fr);
  gap: 10px;
}
.txs-panel {
  background: var(--surface, #fff);
  border: 1px solid var(--line, #eaebf3);
  border-radius: var(--r-lg, 16px);
  padding: 13px 15px;
  box-shadow: var(--sh-sm, 0 1px 2px rgba(16, 18, 40, 0.05));
  min-width: 0;
}
.txs-panel__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}
.txs-panel__head h3 {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 13.5px;
  font-weight: 700;
  color: var(--t-900, #0e1124);
}
.txs-panel__head h3 svg { color: var(--brand-600, #6d5df6); }
.txs-empty { margin: 0; font-size: 12.5px; color: var(--t-400, #9aa0b6); }

/* ---- top assets ---- */
.txs-assets { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 0; }
.txs-asset {
  display: flex;
  align-items: flex-start;
  gap: 11px;
  padding: 0 16px;
  min-width: 0;
  border-left: 1px solid var(--line, #eaebf3);
}
.txs-asset:first-child { padding-left: 0; border-left: none; }
.txs-asset__body { display: flex; flex-direction: column; gap: 3px; min-width: 0; flex: 1 1; }
.txs-asset__top { display: flex; align-items: baseline; justify-content: space-between; gap: 8px; }
.txs-asset__sym { font-size: 13px; font-weight: 600; color: var(--t-700, #3b4059); }
.txs-asset__usd {
  font-size: 15px;
  font-weight: 700;
  color: var(--t-900, #0e1124);
  font-variant-numeric: tabular-nums;
  line-height: 1.2;
}
.txs-asset__bar {
  display: block;
  height: 5px;
  border-radius: 999px;
  background: var(--bg-inset, #eff0f8);
  overflow: hidden;
  margin-top: 4px;
}
.txs-asset__fill {
  display: block;
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(90deg, var(--brand-500, #8b7bff), var(--brand-600, #6d5df6));
  transition: width 0.45s cubic-bezier(0.22, 1, 0.36, 1);
}
.txs-asset__count { font-size: 11.5px; color: var(--t-400, #9aa0b6); }

/* ---- range toggle ---- */
.txs-range {
  display: inline-flex;
  gap: 2px;
  padding: 3px;
  background: var(--bg-inset, #eff0f8);
  border-radius: 999px;
}
.txs-range__btn {
  border: none;
  background: transparent;
  padding: 4px 11px;
  border-radius: 999px;
  font: inherit;
  font-size: 11px;
  font-weight: 700;
  color: var(--t-500, #6c7189);
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}
.txs-range__btn:hover { color: var(--t-900, #0e1124); }
.txs-range__btn.active { background: var(--brand-600, #6d5df6); color: #fff; }

/* ---- activity chart ---- */
.txs-chart {
  display: flex;
  align-items: flex-end;
  gap: 5px;
  height: 74px;
}
.txs-chart--dense { gap: 1px; }
.txs-chart--dense .txs-bar__track { border-radius: 2px; }
.txs-bar {
  flex: 1 1;
  min-width: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
/* The track is always drawn, so a day with no volume reads as a measured zero
   rather than as a bar that failed to render. */
.txs-bar__track {
  flex: 1 1;
  display: flex;
  align-items: flex-end;
  border-radius: 6px;
  background: var(--bg-inset, #eff0f8);
  overflow: hidden;
}
.txs-bar__fill {
  width: 100%;
  border-radius: 6px;
  background: linear-gradient(180deg, var(--brand-400, #a99cff), var(--brand-500, #8b7bff));
  transition: height 0.45s cubic-bezier(0.22, 1, 0.36, 1);
}
.txs-bar.is-today .txs-bar__fill {
  background: linear-gradient(180deg, var(--brand-600, #6d5df6), var(--brand-700, #5847d6));
}
.txs-bar__day {
  font-style: normal;
  text-align: center;
  font-size: 10px;
  font-weight: 600;
  color: var(--t-400, #9aa0b6);
  line-height: 1;
}
.txs-bar.is-today .txs-bar__day { color: var(--brand-700, #5847d6); }

@media (prefers-reduced-motion: reduce) {
  .txs-asset__fill, .txs-bar__fill { transition: none; }
}

@media (max-width: 1200px) {
  .txs-cards { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .txs-panels { grid-template-columns: minmax(0, 1fr); }
}
@media (max-width: 720px) {
  .txs-cards { grid-template-columns: minmax(0, 1fr); }
  .txs-assets { grid-template-columns: minmax(0, 1fr); gap: 14px; }
  .txs-asset { padding: 0; border-left: none; }
  .txs-spark { display: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/transactions/TransactionSummary.css"],"names":[],"mappings":"AAAA;;;;+EAI+E;AAC/E,OAAO,mBAAmB,EAAE,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;;AAE9E,6BAA6B;AAC7B;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;AACA;;wEAEwE;AACxE;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,0CAA0C;EAC1C;;;iBAGe;EACf,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,gCAAgC;EAChC,sCAAsC;EACtC,gCAAgC;EAChC,0DAA0D;AAC5D;AACA;8BAC8B;AAC9B;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,YAAY;AACd;AACA,2BAA2B,8EAA8E,EAAE;AAC3G,2BAA2B,8EAA8E,EAAE;AAC3G,2BAA2B,8EAA8E,EAAE;;AAE3G;EACE,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA,oCAAoC,qCAAqC,EAAE,gCAAgC,EAAE;AAC7G,oCAAoC,qCAAqC,EAAE,+BAA+B,EAAE;AAC5G,oCAAoC,mCAAmC,GAAG,6BAA6B,EAAE;;AAEzG;EACE,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,aAAa;EACb,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,4BAA4B;EAC5B,kCAAkC;EAClC,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;AACpC;AACA,yBAAyB,6BAA6B,EAAE;AACxD,2BAA2B,8BAA8B,EAAE;AAC3D,2BAA2B,4BAA4B,EAAE,gBAAgB,EAAE;AAC3E,iBAAiB,eAAe,EAAE,4BAA4B,EAAE,mBAAmB,EAAE;;AAErF;kEACkE;AAClE;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,wBAAwB;EACxB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,oBAAoB;AACtB;AACA,mBAAmB,UAAU,EAAE,eAAe,EAAE,iCAAiC,EAAE,qBAAqB,EAAE,sBAAsB,EAAE;AAClI,mBAAmB,YAAY,EAAE,aAAa,EAAE;AAChD,2BAA2B,+BAA+B,EAAE;AAC5D,2BAA2B,0BAA0B,EAAE;AACvD,2BAA2B,wBAAwB,EAAE;AACrD,2BAA2B,iCAAiC,EAAE;AAC9D,2BAA2B,4BAA4B,EAAE;AACzD,2BAA2B,0BAA0B,EAAE;;AAEvD,qBAAqB;AACrB;EACE,aAAa;EACb,uDAAuD;EACvD,SAAS;AACX;AACA;EACE,gCAAgC;EAChC,sCAAsC;EACtC,gCAAgC;EAChC,kBAAkB;EAClB,0DAA0D;EAC1D,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;AAC9B;AACA,0BAA0B,gCAAgC,EAAE;AAC5D,aAAa,SAAS,EAAE,iBAAiB,EAAE,4BAA4B,EAAE;;AAEzE,yBAAyB;AACzB,cAAc,aAAa,EAAE,gDAAgD,EAAE,MAAM,EAAE;AACvF;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,YAAY;EACZ,2CAA2C;AAC7C;AACA,yBAAyB,eAAe,EAAE,iBAAiB,EAAE;AAC7D,mBAAmB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,YAAY,EAAE,SAAO,EAAE;AAC3F,kBAAkB,aAAa,EAAE,qBAAqB,EAAE,8BAA8B,EAAE,QAAQ,EAAE;AAClG,kBAAkB,eAAe,EAAE,gBAAgB,EAAE,4BAA4B,EAAE;AACnF;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,kCAAkC;EAClC,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,WAAW;EACX,oBAAoB;EACpB,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,wFAAwF;EACxF,sDAAsD;AACxD;AACA,oBAAoB,iBAAiB,EAAE,4BAA4B,EAAE;;AAErE,2BAA2B;AAC3B;EACE,oBAAoB;EACpB,QAAQ;EACR,YAAY;EACZ,oCAAoC;EACpC,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,mDAAmD;AACrD;AACA,wBAAwB,4BAA4B,EAAE;AACtD,yBAAyB,qCAAqC,EAAE,WAAW,EAAE;;AAE7E,6BAA6B;AAC7B;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,YAAY;AACd;AACA,oBAAoB,QAAQ,EAAE;AAC9B,oCAAoC,kBAAkB,EAAE;AACxD;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;gDACgD;AAChD;EACE,SAAO;EACP,aAAa;EACb,qBAAqB;EACrB,kBAAkB;EAClB,oCAAoC;EACpC,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,yFAAyF;EACzF,uDAAuD;AACzD;AACA;EACE,yFAAyF;AAC3F;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,cAAc;AAChB;AACA,kCAAkC,gCAAgC,EAAE;;AAEpE;EACE,mCAAmC,gBAAgB,EAAE;AACvD;;AAEA;EACE,aAAa,gDAAgD,EAAE;EAC/D,cAAc,qCAAqC,EAAE;AACvD;AACA;EACE,aAAa,qCAAqC,EAAE;EACpD,cAAc,qCAAqC,EAAE,SAAS,EAAE;EAChE,aAAa,UAAU,EAAE,iBAAiB,EAAE;EAC5C,aAAa,aAAa,EAAE;AAC9B","sourcesContent":["/* ==========================================================================\n   Transactions summary — four headline cards over two panels.\n   Everything here is server-computed (/transactions/summary); the page only\n   ever holds one page of rows, so none of it could be derived client-side.\n   ========================================================================== */\n.txs { margin-bottom: 14px; display: flex; flex-direction: column; gap: 10px; }\n\n/* ---- headline cards ---- */\n.txs-cards {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 10px;\n}\n/* Two rows, not one: the icon and label share the top line, the figure and its\n   delta sit below, and the sparkline gets the full width underneath. Laid out\n   side by side, the sparkline landed on top of \"vs. previous 7 days\". */\n.txs-card {\n  position: relative;\n  overflow: hidden;\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr);\n  grid-template-areas:\n    \"icon  label\"\n    \"body  body\"\n    \"spark spark\";\n  align-items: center;\n  column-gap: 9px;\n  row-gap: 2px;\n  padding: 12px 14px 0;\n  background: var(--surface, #fff);\n  border: 1px solid var(--line, #eaebf3);\n  border-radius: var(--r-lg, 16px);\n  box-shadow: var(--sh-sm, 0 1px 2px rgba(16, 18, 40, 0.05));\n}\n/* A wash in the card's own tone. Kept faint: these sit above a dense table and\n   must not compete with it. */\n.txs-card::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  opacity: 0.4;\n}\n.txs-card--violet::after { background: linear-gradient(135deg, rgba(109, 93, 246, 0.07), transparent 60%); }\n.txs-card--blue::after   { background: linear-gradient(135deg, rgba(59, 158, 255, 0.07), transparent 60%); }\n.txs-card--green::after  { background: linear-gradient(135deg, rgba(15, 185, 129, 0.08), transparent 60%); }\n\n.txs-card__icon {\n  grid-area: icon;\n  position: relative;\n  z-index: 1;\n  display: grid;\n  place-items: center;\n  width: 30px;\n  height: 30px;\n  border-radius: 9px;\n}\n.txs-card--violet .txs-card__icon { background: var(--brand-100, #ece9ff); color: var(--brand-600, #6d5df6); }\n.txs-card--blue .txs-card__icon   { background: var(--info-soft, #e8f2ff); color: var(--info-ink, #1c73d6); }\n.txs-card--green .txs-card__icon  { background: var(--ok-soft, #e6f8f1);  color: var(--ok-ink, #0a8f64); }\n\n.txs-card__body {\n  grid-area: body;\n  position: relative;\n  z-index: 1;\n  display: flex;\n  align-items: baseline;\n  flex-wrap: wrap;\n  gap: 4px 10px;\n  min-width: 0;\n}\n.txs-card__label {\n  grid-area: label;\n  position: relative;\n  z-index: 1;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--t-500, #6c7189);\n}\n.txs-card__value {\n  font-size: 20px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: var(--t-900, #0e1124);\n  font-variant-numeric: tabular-nums;\n  line-height: 1.2;\n  flex: 1 0 100%;\n}\n.txs-card__delta {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  font-size: 11.5px;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n}\n.txs-card__delta.is-up { color: var(--ok-ink, #0a8f64); }\n.txs-card__delta.is-down { color: var(--err-ink, #ce2649); }\n.txs-card__delta.is-flat { color: var(--t-400, #9aa0b6); font-weight: 500; }\n.txs-card__sub { font-size: 11px; color: var(--t-400, #9aa0b6); white-space: nowrap; }\n\n/* Bleeds to the card's edges along the bottom, so it reads as a baseline for\n   the figure above rather than a floating decoration beside it. */\n.txs-spark {\n  grid-area: spark;\n  position: relative;\n  z-index: 1;\n  width: calc(100% + 28px);\n  margin: 4px -14px 0;\n  height: 26px;\n  display: block;\n  pointer-events: none;\n}\n.txs-spark__line { fill: none; stroke-width: 2; vector-effect: non-scaling-stroke; stroke-linecap: round; stroke-linejoin: round; }\n.txs-spark__area { stroke: none; opacity: 0.16; }\n.txs-spark__area--violet { fill: var(--brand-600, #6d5df6); }\n.txs-spark__area--blue   { fill: var(--info, #3b9eff); }\n.txs-spark__area--green  { fill: var(--ok, #0fb981); }\n.txs-spark__line--violet { stroke: var(--brand-600, #6d5df6); }\n.txs-spark__line--blue   { stroke: var(--info, #3b9eff); }\n.txs-spark__line--green  { stroke: var(--ok, #0fb981); }\n\n/* ---- panels ---- */\n.txs-panels {\n  display: grid;\n  grid-template-columns: minmax(0, 1.35fr) minmax(0, 1fr);\n  gap: 10px;\n}\n.txs-panel {\n  background: var(--surface, #fff);\n  border: 1px solid var(--line, #eaebf3);\n  border-radius: var(--r-lg, 16px);\n  padding: 13px 15px;\n  box-shadow: var(--sh-sm, 0 1px 2px rgba(16, 18, 40, 0.05));\n  min-width: 0;\n}\n.txs-panel__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 10px;\n}\n.txs-panel__head h3 {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  font-size: 13.5px;\n  font-weight: 700;\n  color: var(--t-900, #0e1124);\n}\n.txs-panel__head h3 svg { color: var(--brand-600, #6d5df6); }\n.txs-empty { margin: 0; font-size: 12.5px; color: var(--t-400, #9aa0b6); }\n\n/* ---- top assets ---- */\n.txs-assets { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 0; }\n.txs-asset {\n  display: flex;\n  align-items: flex-start;\n  gap: 11px;\n  padding: 0 16px;\n  min-width: 0;\n  border-left: 1px solid var(--line, #eaebf3);\n}\n.txs-asset:first-child { padding-left: 0; border-left: none; }\n.txs-asset__body { display: flex; flex-direction: column; gap: 3px; min-width: 0; flex: 1; }\n.txs-asset__top { display: flex; align-items: baseline; justify-content: space-between; gap: 8px; }\n.txs-asset__sym { font-size: 13px; font-weight: 600; color: var(--t-700, #3b4059); }\n.txs-asset__usd {\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--t-900, #0e1124);\n  font-variant-numeric: tabular-nums;\n  line-height: 1.2;\n}\n.txs-asset__bar {\n  display: block;\n  height: 5px;\n  border-radius: 999px;\n  background: var(--bg-inset, #eff0f8);\n  overflow: hidden;\n  margin-top: 4px;\n}\n.txs-asset__fill {\n  display: block;\n  height: 100%;\n  border-radius: 999px;\n  background: linear-gradient(90deg, var(--brand-500, #8b7bff), var(--brand-600, #6d5df6));\n  transition: width 0.45s cubic-bezier(0.22, 1, 0.36, 1);\n}\n.txs-asset__count { font-size: 11.5px; color: var(--t-400, #9aa0b6); }\n\n/* ---- range toggle ---- */\n.txs-range {\n  display: inline-flex;\n  gap: 2px;\n  padding: 3px;\n  background: var(--bg-inset, #eff0f8);\n  border-radius: 999px;\n}\n.txs-range__btn {\n  border: none;\n  background: transparent;\n  padding: 4px 11px;\n  border-radius: 999px;\n  font: inherit;\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--t-500, #6c7189);\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n.txs-range__btn:hover { color: var(--t-900, #0e1124); }\n.txs-range__btn.active { background: var(--brand-600, #6d5df6); color: #fff; }\n\n/* ---- activity chart ---- */\n.txs-chart {\n  display: flex;\n  align-items: flex-end;\n  gap: 5px;\n  height: 74px;\n}\n.txs-chart--dense { gap: 1px; }\n.txs-chart--dense .txs-bar__track { border-radius: 2px; }\n.txs-bar {\n  flex: 1;\n  min-width: 0;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n/* The track is always drawn, so a day with no volume reads as a measured zero\n   rather than as a bar that failed to render. */\n.txs-bar__track {\n  flex: 1;\n  display: flex;\n  align-items: flex-end;\n  border-radius: 6px;\n  background: var(--bg-inset, #eff0f8);\n  overflow: hidden;\n}\n.txs-bar__fill {\n  width: 100%;\n  border-radius: 6px;\n  background: linear-gradient(180deg, var(--brand-400, #a99cff), var(--brand-500, #8b7bff));\n  transition: height 0.45s cubic-bezier(0.22, 1, 0.36, 1);\n}\n.txs-bar.is-today .txs-bar__fill {\n  background: linear-gradient(180deg, var(--brand-600, #6d5df6), var(--brand-700, #5847d6));\n}\n.txs-bar__day {\n  font-style: normal;\n  text-align: center;\n  font-size: 10px;\n  font-weight: 600;\n  color: var(--t-400, #9aa0b6);\n  line-height: 1;\n}\n.txs-bar.is-today .txs-bar__day { color: var(--brand-700, #5847d6); }\n\n@media (prefers-reduced-motion: reduce) {\n  .txs-asset__fill, .txs-bar__fill { transition: none; }\n}\n\n@media (max-width: 1200px) {\n  .txs-cards { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n  .txs-panels { grid-template-columns: minmax(0, 1fr); }\n}\n@media (max-width: 720px) {\n  .txs-cards { grid-template-columns: minmax(0, 1fr); }\n  .txs-assets { grid-template-columns: minmax(0, 1fr); gap: 14px; }\n  .txs-asset { padding: 0; border-left: none; }\n  .txs-spark { display: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
